var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "editInfo-wrap"
  }, [_c('h2', [_vm._v("Billing Address")]), _c('p', [_vm._v("Enter and Update all your Billing Address here.")]), _c('div', {
    staticClass: "information-form"
  }, [_c('ValidationObserver', {
    ref: "observer",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var handleSubmit = _ref.handleSubmit;
        return [_c('form', {
          ref: "employerGroupGeneralInfoContainer",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return handleSubmit(_vm.updateInfo);
            }
          }
        }, [_c('div', {
          staticClass: "form-group row"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "first_name",
            "labelName": "Billing Contact First Name",
            "vmodel": _vm.form.first_name,
            "formGroupClass": "col-xxl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "first_name", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "rules": {
              required: true
            },
            "labelFor": "last_name",
            "labelName": "Billing Contact Last Name",
            "vmodel": _vm.form.last_name,
            "formGroupClass": "col-xxl-4 col-lg-4 col-md-6 mb-3"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "last_name", $event);
            }
          }
        }), _c('input-text', {
          attrs: {
            "rules": {
              required: false
            },
            "labelFor": "billing_fax",
            "labelName": "FAX",
            "vmodel": _vm.form.fax,
            "formGroupClass": "col-xxl-4 col-lg-4 col-md-6 mb-3",
            "placeholder": "FAX (no dashes eg: 123456789)"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "fax", $event);
            }
          }
        })], 1), _c('div', {
          staticClass: "form-group row"
        }, [_c('span', {
          staticClass: "col-xxl-4 col-lg-6 col-md-6 mb-3"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true,
              email: true
            },
            "labelFor": "billing_email",
            "labelName": "Email",
            "vmodel": _vm.form.email,
            "formGroupClass": ""
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "email", $event);
            }
          }
        }), _c('div', {
          staticClass: "mt-3 row justify-content-between validation-row"
        }, [_vm.showOtpSectionEmail ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-billing-otp-validation"
        }, [_c('a', {
          staticClass: "validate-via-otp-link",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('email');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. ")])]) : _vm._e()]), _vm.emailMsg ? _c('div', {
          staticClass: "message-container mt-2"
        }, [_c('div', {
          class: ['validate-message', "".concat(_vm.emailValidationMessage.type)]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.emailValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.emailValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.emailValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.emailValidationMessage.message) + " ")]), _c('button', {
          staticClass: "close-btn",
          attrs: {
            "type": "button",
            "onclick": "this.parentElement.style.display='none';"
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])])]) : _vm._e()], 1), _c('span', {
          staticClass: "col-xxl-4 col-lg-6 col-md-6 mb-3"
        }, [_c('input-text', {
          attrs: {
            "rules": {
              required: true,
              digits: 10
            },
            "labelFor": "billing_phone",
            "labelName": "Phone",
            "vmodel": _vm.form.phone,
            "formGroupClass": "",
            "placeholder": "Phone (no dashes eg: 123456789)",
            "inputType": "text",
            "maxlength": "10",
            "inputmode": "numeric",
            "pattern": "\\d*"
          },
          on: {
            "update:vmodel": function updateVmodel($event) {
              return _vm.$set(_vm.form, "phone", $event);
            }
          },
          nativeOn: {
            "input": function input($event) {
              return _vm.enforceDigitLimit.apply(null, arguments);
            },
            "keypress": function keypress($event) {
              return _vm.onlyAllowDigits.apply(null, arguments);
            }
          }
        }), _c('div', {
          staticClass: "mt-3 row justify-content-between validation-row"
        }, [_vm.showOtpSectionPhone ? _c('span', {
          staticClass: "validate-btn col-md-5 col-sm-6 d-flex rep-billing-otp-validation"
        }, [_c('a', {
          staticClass: "validate-via-otp-link",
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openOtpModal('phone');
            }
          }
        }, [_vm._v(" TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. ")])]) : _vm._e()]), _vm.phoneMsg ? _c('div', {
          staticClass: "message-container mt-2"
        }, [_c('div', {
          class: ['validate-message', "".concat(_vm.phoneValidationMessage.type)]
        }, [_c('div', {
          class: ['message-indicator', "".concat(_vm.phoneValidationMessage.type, "-indicator")]
        }), _c('span', {
          staticClass: "message-text"
        }, [_c('strong', {
          class: "".concat(_vm.phoneValidationMessage.type, "-text")
        }, [_vm._v(_vm._s(_vm.phoneValidationMessage.title))]), _vm._v(" - " + _vm._s(_vm.phoneValidationMessage.message) + " ")]), _c('button', {
          staticClass: "close-btn",
          attrs: {
            "type": "button",
            "onclick": "this.parentElement.style.display='none';"
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])])]) : _vm._e()], 1)]), _c('employer-group-billing-address-content', {
          attrs: {
            "addresses": _vm.billingAddresses,
            "type": "billing"
          }
        }), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-12"
        }, [_c('button', {
          staticClass: "univ-btn",
          attrs: {
            "type": "submit"
          }
        }, [_vm._v(" " + _vm._s(_vm.isUpdate ? "Updating" : "Update") + " ")])])])], 1), _vm.showOtpModal ? _c('employer-email-verification', {
          attrs: {
            "identifier": _vm.contactInfo,
            "identifierTypeText": _vm.otpType
          },
          on: {
            "save": _vm.handleVerificationResult,
            "close": _vm.closeOtpModal
          },
          model: {
            value: _vm.showOtpModal,
            callback: function callback($$v) {
              _vm.showOtpModal = $$v;
            },
            expression: "showOtpModal"
          }
        }) : _vm._e()];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }